import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';


export const controlledAccordionStyles = makeStyles((theme) => ({
    controlledAccordionWrapper: {
        background: tcsmColors.greyFive,
        '& .MuiAccordion-root': {
            marginBottom: '0',
            background: 'transparent',
            border: 'none',
            boxShadow: 'none',
            '& .Mui-disabled': {
                opacity: '1',
                '& .MuiButtonBase-root': {
                    display: 'none',
                },
            },
            '&-checkbox': {
                padding: '0 2rem 2rem 2rem',
            },
        },
        '& .MuiAccordionSummary': {
            '&-root': {
                '&.Mui-expanded': {
                    minHeight: '0',
                },
            },
            '&-content': {
                '&.Mui-expanded': {
                    marginTop: theme.spacing(.75),
                    marginBottom: theme.spacing(.75),
                },
            },

        },
    },

}));



